<template>
    <div id="FishInfo">
        <div class="fish-content">
            <div class="content-left">
                <div class="item-block">
                    <div
                        class="item-block-item"
                        v-for="(item, index) of fishList"
                        :key="index"
                        @click="toDetails(item)">
                        <div class="item-block-banner">
                            <img v-if="item.fileUrl" :src="item.fileUrl" alt="">
                        </div>
                        <div class="item-block-info">
                            <div class="type">{{item.secondType || '海钓'}}</div>
                            <p>{{item.title}}</p>
                            <p>{{item.profile}}</p>
                            <p>
                                <img src="../../assets/img/时间.png" alt="">
                                <span>{{item.addTime}}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-right">
                <!--            <div class="code">-->
                <!--                <img src="../../assets/img/二维码示意.png" alt="">-->
                <!--                <p>扫码下载，也可在应用商店搜索「海钓」下载</p>-->
                <!--            </div>-->
                <div class="right-block">
                    <div class="right-title">
                        <img src="../../assets/img/点.png" alt="">
                        <span>今日推荐</span>
                    </div>
                    <div class="recommend">
                        <div class="recommend-item" v-for="(item, index) of recommendList" :key="index" @click="toDetails(item)">
                            <div class="recommend-banner">
                                <img :src="item.fileUrl" alt="">
                            </div>
                            <p>{{item.title}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pagination">
            <el-pagination
                background
                layout="prev, pager, next"
                @current-change="currentChange"
                :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FishInfo',
        data() {
            return {
                fishList: [],
                total: 0,
                recommendList: [
                    {
                        title: '如何立足优势、深挖特色，是舟山旅游一直思考的问题,舟山海钓是旅游的一种方式',
                        img: require('../../assets/img/pic4.png')
                    },
                    {
                        title: '如何立足优势、深挖特色，是舟山旅游一直思考的问题,舟山海钓是旅游的一种方式',
                        img: require('../../assets/img/pic5.png')
                    },
                    {
                        title: '如何立足优势、深挖特色，是舟山旅游一直思考的问题,舟山海钓是旅游的一种方式',
                        img: require('../../assets/img/pic6.png')
                    }
                ],
                // 筛选信息
                form: {
                    area: '',
                    type: '',
                    pageNum: '1',
                    pageSize: '10'
                }
            }
        },
        methods: {
            /**
             * 获得类型
             */
            getType() {
                this.form.type = this.$route.query.type
            },
            getListData() {
                this.$common.querystringifyPost('/hdweb/portal/getPropagateInfo', this.form).then(res => {
                    console.log(res)
                    this.fishList = res.data.rows
                    this.total = res.data.total
                })
            },
            currentChange(pageNum) {
                console.log(pageNum)
                this.form.pageNum = pageNum
                this.getFinshingList()
            },
            toDetails(item) {
                this.$router.push({
                    path: '/InfoDetails',
                    query: {
                        id: item.id,
                        type: 'xuan'
                    }
                })
            },
            getRecommend() {
                this.$common.querystringifyPost('/hdweb/portal/getPropagateInfoRecomm', {
                    recommend: '1',
                    pageNum: '1',
                    pageSize: '3'
                }).then(res => {
                    console.log(res)
                    this.recommendList = res.data.rows
                })
            }
        },
        created() {
            this.getType()
            this.getListData()
            this.getRecommend()
        },
        watch: {
            '$route.query.type': {
                deep: true,
                handler: function (newVal) {
                    this.form.type = newVal
                    this.getListData()
                }
            }
        }
    }
</script>

<style scoped lang="less">
    #FishInfo {
        width: 1200px;
        margin: 0 auto;

        .fish-content {
            width: 1200px;
            margin: 0 auto;
            display: flex;
            justify-content: space-between
        }

        .content-left {
            width: 65%;
            /*background: #42b983;*/

            .item-block {
                width: 100%;

                .item-block-item {
                    margin: 20px 0;
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 10px;
                    transition: all .5s;

                    &:hover {
                        box-shadow: 0px 2px 16px 2px rgba(0, 0, 0, 0.1);
                    }

                    .item-block-banner {
                        width: 216px;
                        height: 142px;
                        /*width: 35%;*/
                        /*height: 150px;*/
                        overflow: hidden;

                        img {
                            width: 100%;
                            height: 100%;
                            transition: all .5s;
                            object-fit: cover;
                            &:hover {
                                transform: scale(1.4);
                            }
                        }
                    }

                    .item-block-info {
                        width: calc(100% - 240px);
                        height: 142px;

                        .type {
                            width: 64px;
                            height: 20px;
                            background: rgba(5, 160, 130, .1);
                            border-radius: 2px;
                            color: rgba(5, 160, 130, 1);
                            text-align: center;
                            line-height: 20px;
                            font-size: 12px;
                        }

                        p:nth-of-type(1) {
                            margin-top: 6px;
                            font-size: 18px;
                        }

                        p:nth-of-type(2) {
                            font-size: 12px;
                            margin-top: 16px;
                            color: rgba(102, 102, 102, 1);
                            line-height: 18px;
                            height: 36px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                        }

                        p:nth-of-type(3) {
                            margin-top: 20px;
                            font-size: 12px;
                            color: rgba(153, 153, 153, 1);
                        }
                    }
                }
            }
        }

        .content-right {
            width: 32%;

            .right-title {
                margin-top: 30px;

                img {
                    margin-right: 5px;
                }

                color: rgba(51, 51, 51, 1);
                font-size: 18px;
            }

            .recommend {
                margin: 15px 0 30px;

                .recommend-banner {
                    width: 100%;
                    height: 180px;
                    overflow: hidden;
                    display: flex;
                    align-items: center;
                    img {
                        width: 100%;
                        height: 100%;
                        transition: all .5s;
                        object-fit: cover;
                        &:hover {
                            transform: scale(1.4);
                        }
                    }
                }

                p {
                    margin: 10px 0 25px;
                    color: #222222;
                    height: 34px;
                    line-height: 17px;
                    overflow: hidden;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/fish-info/FishInfo.vue